/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthSsoCallbackRequest, AuthSsoCallbackResponse } from '../types/AuthSsoCallback'

/**
 * POST /auth/sso/callback
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::ssoCallback
 */
export async function authSsoCallback(
	data: AuthSsoCallbackRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthSsoCallbackResponse>> {
	return axiosInstance.post('/auth/sso/callback', data, config)
}
